import './App.css';
import Home from './sections/home';
import AboutUS from './sections/aboutUs';
import Services from './sections/services';
import Team from './sections/team';
import Navbar from './components/Navbar';
import ContactUs from './sections/contactUs';
import Portfolio from './sections/portfolio';
import MapNavigation from './sections/mapNavigation';
import Footer from './sections/footer';
import Equipments from './sections/equipments';
import UPButton from './components/UPButton';
function App() {
  return (
    <div className="App">
      <Navbar />
      <Home />
      <AboutUS />
      <Services />
      <Team />
      <Portfolio />
      <Equipments />
      <ContactUs />
      <MapNavigation />
      <Footer />
      <UPButton />
    </div>
  );
}

export default App;
